import type { ClientProposal } from "../proposalTypes";

const GREAT_JONES =
  "https://storage.googleapis.com/cuo-website/Great%20Jones%20BILT.jpg";
const HERO = "https://storage.googleapis.com/cuo-website/Chris+Distefano+at+Wilson.jpg";
const SEVILLE =
  "https://storage.googleapis.com/cuo-website/Screenshot%202026-10-09%20at%201.01.39%E2%80%AFPM.png";
const PARAGON_STAGE = "https://storage.googleapis.com/cuo-website/Paragon+Stage.jpg";
const DAN_SODER = "/images/Dan_Soder_Economy_Candy.jpg";
const CROWD = "/images/Economy_Candy_Crowd.jpg";
const KATZ = "/images/Katz_s_Storefront.jpg";
const THIRTEENTH_STOREY =
  "https://storage.googleapis.com/cuo-website/Rooms%20We've%20Fooled%20Magic%20Show.jpg";
const GREAT_JONES_SHOW =
  "https://storage.googleapis.com/cuo-website/Eric%20Nueman%20Great%20Jones.jpg";
const GREAT_JONES_ROOM =
  "https://storage.googleapis.com/cuo-website/Great%20Jones%20Squatch.jpg";
const SKEWR = "https://storage.googleapis.com/cuo-website/Skewr.jpg";
const DCTV_FIREHOUSE =
  "https://storage.googleapis.com/cuo-website/DCTV%20Firehouse.jpg";
const MAGIC_CLOSEUP =
  "https://storage.googleapis.com/cuo-website/Dim%20Sum%20Magic%20Show.jpg";
const MAGIC_SHOW =
  "https://storage.googleapis.com/cuo-website/Astor%20Place%20Magic%20Show.jpg";

export const beazleyProposal: ClientProposal = {
  slug: "beazley",
  clientName: "Beazley",
  clientLogo: "https://storage.googleapis.com/cuo-website/Beazley%20Logo%20Nov%202022.png",
  comedyuoLogo: "/images/Comedy_UO_logo_whiteversion_edited.png",
  eventTitle: "January 2027 Holiday Office Party",
  eventSubtitle: "A private New York City celebration for the Beazley team",
  heroImage: HERO,
  heroEyebrow: "A PRIVATE EXPERIENCE BY COMEDYUO",
  heroHeadline: "An Office Party Worth Talking About.",
  heroSubheadline:
    "A private New York City celebration with exceptional food, cocktails, and live entertainment: comedy, a full magic night, or a comedy + magic variety show, curated exclusively for the Beazley team.",
  summaryItems: [
    "50–60 Guests",
    "January 2027",
    "Wednesday or Thursday Evening",
    "Comedy, Magic, or Variety",
  ],
  guestCount: "50–60",
  experienceTitle: "A Night That Doesn't Feel Like an Office Party.",
  experienceIntro:
    "Forget the typical banquet room and predictable company celebration. We're bringing Beazley together for an evening built around great food, incredible company, and some of New York's funniest performers, all inside a distinctive NYC venue.",
  experiencePillars: [
    {
      number: "01",
      title: "An Iconic Setting",
      body: "A curated private venue with the atmosphere and character of New York City.",
      image: KATZ,
      imageAlt: "An iconic New York venue exterior",
    },
    {
      number: "02",
      title: "Food & Cocktails",
      body: "A welcoming reception with food, drinks, and plenty of time to socialize.",
      image: CROWD,
      imageAlt: "Guests mingling at a ComedyUO event",
    },
    {
      number: "03",
      title: "A Private Comedy Show",
      body: "A professionally produced performance from experienced New York comedians, tailored to the Beazley audience.",
      image: DAN_SODER,
      imageAlt: "A comedian performing at a ComedyUO show",
    },
  ],
  featuredCaseStudy: {
    venueId: "great-jones",
    venueName: "Great Jones Distilling Co.",
    eyebrow: "Case study · ~60–70 guests",
    title: "A private comedy club inside a Manhattan distillery.",
    guestCount: "~60–70 guests",
    body: "Great Jones sits right in Beazley's headcount range. We produced a full showcase in the downstairs room: cocktails, low ceilings, and a packed intimate audience. The photo is from a real ComedyUO night there.",
    photo: GREAT_JONES_SHOW,
    photoAlt: "Eric Neumann performing at Great Jones Distillery",
    eventLabel: "ComedyUO at Great Jones Distilling Co. · NoHo",
  },
  venues: [
    {
      id: "great-jones",
      name: "Great Jones Distilling Co.",
      positioning: "A Cocktail Party With Character.",
      neighborhood: "NoHo",
      description:
        "Manhattan whiskey distillery energy: warm wood, art deco detail, and a room that works for a standing reception with space for a private show.",
      highlights: [
        "Distinctive downtown NYC distillery",
        "Upscale cocktail atmosphere",
        "Natural fit for a standing reception",
        "Intimate downstairs room suited to comedy",
        "Food and beverage on site",
      ],
      layout: "Standing cocktail reception with a defined performance area",
      guestFit: "Comfortable for ~70 guests (strong fit for 50–60)",
      foodBeverage: "Distillery bar and food service (details subject to confirmation)",
      entertainmentSetup: "Intimate room scale suited to a private showcase",
      costCategory: "Pricing subject to confirmation",
      availability: "Availability Pending",
      heroImage: GREAT_JONES,
      gallery: [
        { src: GREAT_JONES, alt: "Great Jones Distilling Co. interior" },
        { src: GREAT_JONES_SHOW, alt: "Eric Neumann performing at Great Jones" },
        { src: GREAT_JONES_ROOM, alt: "Great Jones Distillery during a ComedyUO night" },
      ],
      caseStudy: {
        eyebrow: "We produced this night",
        title: "Distillery showcase in NoHo",
        guestCount: "~60–70 guests",
        body: "We turned the downstairs room at Great Jones into a private comedy club: low ceilings, cocktails in hand, and a packed intimate audience.",
        photo: GREAT_JONES_SHOW,
        photoAlt: "Eric Neumann performing at the Great Jones Distillery show",
        eventLabel: "Great Jones Distillery · ComedyUO taping",
      },
    },
    {
      id: "seville",
      name: "The Seville",
      positioning: "Speakeasy Comedy Under a Historic Hotel.",
      neighborhood: "NoMad",
      description:
        "A speakeasy comedy room nestled below a historic Manhattan hotel. Cocktails, low ceilings, and an intimate basement setting that feels distinctly New York.",
      highlights: [
        "True speakeasy basement energy",
        "Food and bar handled by The Seville",
        "Built for an intimate comedy showcase",
        "Historic hotel address in NoMad",
        "ComedyUO has produced here before",
      ],
      layout: "Cocktail reception into a seated basement showcase",
      guestFit: "Intimate room (~45 listed capacity; confirm fit for 50–60)",
      foodBeverage: "The Seville kitchen and bar",
      entertainmentSetup: "Basement comedy showcase with tight sightlines",
      costCategory: "Pricing subject to confirmation",
      availability: "Availability Pending",
      heroImage: SEVILLE,
      gallery: [{ src: SEVILLE, alt: "The Seville comedy room" }],
      caseStudy: {
        eyebrow: "We produced this night",
        title: "Basement speakeasy showcase",
        guestCount: "Intimate seated house",
        body: "ComedyUO has already worked The Seville: cocktail-and-comedy in a historic hotel basement that feels like a private club.",
        photo: SEVILLE,
        photoAlt: "The Seville during a ComedyUO night",
        eventLabel: "The Seville · ComedyUO show",
      },
    },
    {
      id: "thirteenth-storey",
      name: "13th Storey",
      positioning: "A Hidden Midtown Rooftop.",
      neighborhood: "Midtown · Near Grand Central",
      description:
        "Private rooftop speakeasy-lounge above Midtown: warm indoor lounge, chef's kitchen, and a 1,500 sq ft terrace. Ideal for a polished reception that still feels intimate. ComedyUO has already produced both comedy and magic nights here.",
      highlights: [
        "Fully private Midtown rooftop",
        "Indoor lounge plus outdoor terrace",
        "Bring-your-own catering flexibility",
        "Minutes from Grand Central",
        "ComedyUO has produced comedy and magic nights here",
      ],
      layout: "Cocktail reception flowing indoor to terrace, then seated or standing show",
      guestFit: "~70 seated / up to ~150 cocktail (excellent for 50–60)",
      foodBeverage: "Outside catering welcome, or ComedyUO-coordinated F&B",
      entertainmentSetup: "Intimate salon-scale performance (stage layout TBD with venue)",
      costCategory: "Pricing subject to confirmation",
      availability: "Availability Pending",
      heroImage: THIRTEENTH_STOREY,
      gallery: [
        { src: THIRTEENTH_STOREY, alt: "ComedyUO at 13th Storey" },
        { src: PARAGON_STAGE, alt: "ComedyUO production reference" },
      ],
      caseStudy: {
        eyebrow: "We produced this night",
        title: "Comedy and magic on a Midtown rooftop",
        guestCount: "Intimate Midtown salon",
        body: "We've already activated 13th Storey for private comedy and magic nights: speakeasy lounge energy upstairs in Midtown, close to Grand Central.",
        photo: THIRTEENTH_STOREY,
        photoAlt: "ComedyUO night at 13th Storey",
        eventLabel: "13th Storey · ComedyUO comedy & magic",
      },
    },
    {
      id: "skewr",
      name: "Skewr",
      positioning: "Mediterranean Dinner, Then Laughs.",
      neighborhood: "Rose Hill · East 27th Street",
      description:
        "Through a curtained doorway sits an elevated Mediterranean dining room with an open kitchen as the backdrop. Clean cuisine, cocktails, and a room scaled for an intimate corporate night.",
      highlights: [
        "Open-kitchen dining room energy",
        "Food and bar handled by Skewr",
        "Strong fit near ~65 guests",
        "Polished without feeling banquet",
        "ComedyUO has produced here before",
      ],
      layout: "Seated dinner / reception into a comedy showcase in the dining room",
      guestFit: "~65 guests (excellent for 50–60)",
      foodBeverage: "Skewr kitchen and bar",
      entertainmentSetup: "Dining-room showcase with open kitchen as backdrop",
      costCategory: "Pricing subject to confirmation",
      availability: "Availability Pending",
      heroImage: SKEWR,
      gallery: [{ src: SKEWR, alt: "Skewr dining room" }],
      caseStudy: {
        eyebrow: "We produced this night",
        title: "Comedy with an open kitchen",
        guestCount: "~65 guests",
        body: "Skewr's curtained dining room is built for an intimate night: Mediterranean plates, cocktails, and a comedy showcase against the open kitchen.",
        photo: SKEWR,
        photoAlt: "Skewr restaurant during a ComedyUO activation",
        eventLabel: "Skewr · ComedyUO private night",
      },
    },
    {
      id: "dctv-firehouse",
      name: "DCTV Firehouse",
      positioning: "A Landmark Room With Presence.",
      neighborhood: "Tribeca / Downtown",
      description:
        "A historic firehouse turned production and event space. Character walls, a room that photographs beautifully, and enough volume for a 50–60 person reception plus private show.",
      highlights: [
        "Distinctive historic firehouse setting",
        "Strong presence for a holiday party",
        "Flexible layout for mingling then showtime",
        "Downtown location with easy access",
        "Memorable alternative to a standard restaurant buyout",
      ],
      layout: "Standing reception into a defined performance area",
      guestFit: "Comfortable for 50–60 with room to mingle",
      foodBeverage: "Catering coordinated by ComedyUO (subject to confirmation)",
      entertainmentSetup: "Private showcase with production-friendly room",
      costCategory: "Pricing subject to confirmation",
      availability: "Availability Pending",
      heroImage: DCTV_FIREHOUSE,
      gallery: [{ src: DCTV_FIREHOUSE, alt: "DCTV Firehouse event space" }],
    },
  ],
  entertainmentTitle: "Choose Your Night: Comedy, Magic, or Variety.",
  entertainmentIntro:
    "Three clear formats. A full comedy night, a full magic night, or a Comedy + Magic variety show that blends both. Pick the tone that fits Beazley's holiday party.",
  entertainmentOptions: [
    {
      id: "comedy",
      label: "Comedy",
      tagline: "Private stand-up showcase",
      description:
        "A hosted stand-up show built like a private comedy club: professional comics, clean or workplace-appropriate material, and a clear run of show. Guests mingle, then sit for roughly 45–60 minutes of laughs.",
      bestFor:
        "Teams that want a high-energy shared moment and a classic comedy-club night.",
      includes: [
        "Professional host / emcee",
        "Two professional stand-up comedians",
        "Approximately 45–60 minutes of comedy",
        "Clean or workplace-appropriate material, tailored to Beazley",
        "Basic sound and stage setup",
        "Talent booking and show production by ComedyUO",
      ],
      pricingNote: "Stand-alone comedy night",
      image: DAN_SODER,
      imageAlt: "Stand-up comedian performing at a ComedyUO show",
    },
    {
      id: "magic",
      label: "Magic",
      tagline: "Full private magic night",
      description:
        "A complete magic experience, not just a cocktail-hour add-on. Close-up, mentalism, and stage moments curated for a private room, with the same production care as our comedy nights. Magician roster subject to availability.",
      bestFor:
        "Teams that want wonder, intimacy, and conversation-stopping moments as the main event.",
      includes: [
        "Professional magic host / lead magician",
        "Close-up and/or parlor magic tailored to the room",
        "Approximately 45–60 minutes of featured magic",
        "Optional roaming magic during the reception",
        "Basic sound and staging as needed",
        "Talent booking and show production by ComedyUO",
      ],
      pricingNote: "Stand-alone full magic night (pricing subject to confirmation)",
      pricingTbd: true,
      image: MAGIC_SHOW,
      imageAlt: "ComedyUO private magic show",
    },
    {
      id: "comedy-magic",
      label: "Comedy + Magic [Variety Show]",
      tagline: "The best of both",
      description:
        "A variety night that combines stand-up comedy with magic: roaming or featured magic woven around a comedy showcase so the evening feels bigger than a single format. Magic and comedy roster subject to availability.",
      bestFor:
        "Groups that want mingling energy, surprises, and a shared show that feels like a private variety club.",
      includes: [
        "Professional comedy host / emcee",
        "Stand-up comedians for a featured showcase",
        "Magician(s) for roaming and/or featured spots",
        "A blended run of show across comedy and magic",
        "Basic sound and stage setup",
        "Talent booking and show production by ComedyUO",
      ],
      pricingNote: "Variety format pricing confirmed against final budget and availability",
      pricingTbd: true,
      image: MAGIC_CLOSEUP,
      imageAlt: "Close-up magic and comedy energy at a ComedyUO private event",
    },
  ],
  timelineTitle: "The Run of Show",
  timelineNote: "All times illustrative and adjustable to venue availability and entertainment format.",
  timeline: [
    {
      time: "6:00 PM",
      title: "Doors Open",
      body: "Welcome drinks, food, music, and mingling. On Magic or Variety nights, roaming magic can begin here.",
    },
    {
      time: "6:45 PM",
      title: "The Reception",
      body: "Guests enjoy food, cocktails, and conversation.",
    },
    {
      time: "7:30 PM",
      title: "Showtime",
      body: "A professionally produced 45–60-minute showcase: comedy, magic, or variety, based on your selection.",
    },
    {
      time: "8:30 PM",
      title: "Drinks & Socializing",
      body: "Guests reconnect and enjoy the rest of the evening.",
    },
    {
      time: "9:00 PM",
      title: "Event Concludes",
      body: "A clean wrap, or extend if the room allows.",
    },
  ],
  handlesTitle: "You Enjoy the Party. We Handle the Rest.",
  handles: [
    "Venue coordination",
    "Entertainment booking",
    "Food and beverage coordination",
    "Technical production",
    "Show programming",
    "Event staffing coordination",
    "Timeline and run of show",
    "Day-of event management",
  ],
  clientsTitle: "Examples of who we've worked with",
  clientsIntro:
    "ComedyUO produces private comedy and magic nights for law firms, finance teams, member clubs, and brands across New York City.",
  clientLogos: [
    { src: "/images/private-events-BILT_Rewards_Logo.png", alt: "BILT Rewards" },
    { src: "/images/private-events-Polymarket.png", alt: "Polymarket" },
    {
      src: "https://storage.googleapis.com/cuo-website/JP+Morgan+Logo+(1).png",
      alt: "J.P. Morgan",
      height: 128,
      maxWidth: 400,
    },
    {
      src: "https://storage.googleapis.com/cuo-website/Akin+Gump+Logo.jpg",
      alt: "Akin",
    },
    { src: "/images/private-events-YPO_Logo.png", alt: "YPO" },
    {
      src: "/images/private-events-Norton_Rose_Fulbright_Logo.png",
      alt: "Norton Rose Fulbright",
      height: 88,
      maxWidth: 300,
    },
    { src: "/images/private-events-Skadden_Arps_Logo.png", alt: "Skadden" },
    { src: "/images/private-events-Proskauer_Rose_Logo.png", alt: "Proskauer" },
    {
      src: "/images/private-events-Moritt_Hock_Hamroff_LLP.png",
      alt: "Moritt Hock & Hamroff LLP",
      height: 88,
      maxWidth: 300,
    },
    { src: "/images/private-events-Sydecar.png", alt: "Sydecar" },
  ],
  nextStepsTitle: "Let's Make It a Night to Remember.",
  nextStepsBody:
    "We'd love to create a fantastic evening for the Beazley team. Once you've identified your preferred venue, date, and entertainment format, we'll confirm availability, finalize the event plan, and prepare a detailed quote. ComedyUO will follow up directly by email.",
  contactName: "ComedyUO",
  dateOptions: [
    { id: "2027-01-13", label: "Wednesday, January 13, 2027", isoDate: "2027-01-13" },
    { id: "2027-01-14", label: "Thursday, January 14, 2027", isoDate: "2027-01-14" },
    { id: "2027-01-20", label: "Wednesday, January 20, 2027", isoDate: "2027-01-20" },
    { id: "2027-01-21", label: "Thursday, January 21, 2027", isoDate: "2027-01-21" },
  ],
  accessEnvKey: "VITE_PROPOSAL_BEAZLEY_ACCESS_CODE",
};
